import { render } from "./LoadingPage.vue?vue&type=template&id=26069616&scoped=true"
const script = {}

import "./LoadingPage.vue?vue&type=style&index=0&id=26069616&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.5_vue@3.4.5_typescript@5.4.5__webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26069616"]])

export default __exports__